module.exports = __webpack_public_path__ + "media/mypage/images/ajax-loader-dd14c1aa03ee35c59b552958ea961bcd.gif";